import React__default, { createContext, useContext, useState, useMemo, useId } from "react";
import { useEvent as o } from "../../hooks/use-event.js";
import { useIsoMorphicEffect as n } from "../../hooks/use-iso-morphic-effect.js";
import { useSyncRefs as y } from "../../hooks/use-sync-refs.js";
import { useDisabled as a } from "../../internal/disabled.js";
import { useProvidedId as u } from "../../internal/id.js";
import { forwardRefWithAs as W, render as H } from "../../utils/render.js";
let c = createContext(null);
c.displayName = "LabelContext";
function P() {
  let r = useContext(c);
  if (r === null) {
    let l = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(l, P), l;
  }
  return r;
}
function I(r) {
  var a2, e, o2;
  let l = (e = (a2 = useContext(c)) == null ? void 0 : a2.value) != null ? e : void 0;
  return ((o2 = r == null ? void 0 : r.length) != null ? o2 : 0) > 0 ? [l, ...r].filter(Boolean).join(" ") : l;
}
function z({ inherit: r = false } = {}) {
  let l = I(), [a2, e] = useState([]), o$1 = r ? [l, ...a2].filter(Boolean) : a2;
  return [o$1.length > 0 ? o$1.join(" ") : void 0, useMemo(() => function(t) {
    let s = o((i) => (e((p) => [...p, i]), () => e((p) => {
      let u2 = p.slice(), d = u2.indexOf(i);
      return d !== -1 && u2.splice(d, 1), u2;
    }))), m = useMemo(() => ({ register: s, slot: t.slot, name: t.name, props: t.props, value: t.value }), [s, t.slot, t.name, t.props, t.value]);
    return React__default.createElement(c.Provider, { value: m }, t.children);
  }, [e])];
}
let N = "label";
function G(r, l) {
  var y$1;
  let a$1 = useId(), e = P(), o$1 = u(), g = a(), { id: t = `headlessui-label-${a$1}`, htmlFor: s = o$1 != null ? o$1 : (y$1 = e.props) == null ? void 0 : y$1.htmlFor, passive: m = false, ...i } = r, p = y(l);
  n(() => e.register(t), [t, e.register]);
  let u$1 = o((L) => {
    let b = L.currentTarget;
    if (b instanceof HTMLLabelElement && L.preventDefault(), e.props && "onClick" in e.props && typeof e.props.onClick == "function" && e.props.onClick(L), b instanceof HTMLLabelElement) {
      let n2 = document.getElementById(b.htmlFor);
      if (n2) {
        let E = n2.getAttribute("disabled");
        if (E === "true" || E === "") return;
        let x = n2.getAttribute("aria-disabled");
        if (x === "true" || x === "") return;
        (n2 instanceof HTMLInputElement && (n2.type === "radio" || n2.type === "checkbox") || n2.role === "radio" || n2.role === "checkbox" || n2.role === "switch") && n2.click(), n2.focus({ preventScroll: true });
      }
    }
  }), d = g || false, C = useMemo(() => ({ ...e.slot, disabled: d }), [e.slot, d]), f = { ref: p, ...e.props, id: t, htmlFor: s, onClick: u$1 };
  return m && ("onClick" in f && (delete f.htmlFor, delete f.onClick), "onClick" in i && delete i.onClick), H({ ourProps: f, theirProps: i, slot: C, defaultTag: s ? N : "div", name: e.name || "Label" });
}
let U = W(G), K = Object.assign(U, {});
export {
  K as Label,
  P as useLabelContext,
  I as useLabelledBy,
  z as useLabels
};
